import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import theme from "../theme";

// Optional: styled to force it full screen and above all elements
const FullScreenBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: 13010, // very high z-index to overlay everything
}));

const BackdropLoader = ({ open }) => {
  return (
    <FullScreenBackdrop open={open}>
      <CircularProgress
        size={50}
        sx={{ color: theme.palette.primary.main }}
      />
    </FullScreenBackdrop>
  );
};

export default BackdropLoader;
